import * as React from "react";
import { ExpandedSectionToggleWrapper } from "components/common/EntityDataTable";
import { TypeCell, NodeCell, ThroughputCell } from "components/inputs/InputsOveriew";
import FailuresCell from "components/inputs/InputsOveriew/cells/FailuresCell";
import MessageCountCell from "components/inputs/InputsOveriew/cells/MessageCountCell";
import ExtractorCountCell from "components/inputs/InputsOveriew/cells/ExtractorCountCell";
import AssociatedStreamsCell from "components/inputs/InputsOveriew/cells/AssociatedStreamsCell";
import { METRIC_COLUMN_IDS } from "components/inputs/InputsOveriew/metricColumns";
import { InputStateBadge } from "components/inputs";
import Routes from "routing/Routes";
import { Link } from "components/common";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
const EXPANDED_SECTION = "configuration";
const customColumnRenderers = ({ inputTypes, inputStates }) => ({
  attributes: {
    title: {
      renderCell: (_title, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id, section: EXPANDED_SECTION }, /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.INPUT_DIAGNOSIS(input.id), title: `show input diagnosis for ${input.title}` }, input.title))
    },
    type: {
      renderCell: (type, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id, section: EXPANDED_SECTION }, /* @__PURE__ */ React.createElement(TypeCell, { type, inputTypes }))
    },
    desired_state: {
      renderCell: (_state, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id, section: EXPANDED_SECTION }, /* @__PURE__ */ React.createElement(InputStateBadge, { input, inputStates })),
      staticWidth: 130
    },
    node_id: {
      renderCell: (_type, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id, section: EXPANDED_SECTION }, /* @__PURE__ */ React.createElement(NodeCell, { input })),
      staticWidth: COLUMN_WIDTH.reference
    },
    traffic: {
      renderCell: (_traffic, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id, section: EXPANDED_SECTION, align: "right" }, /* @__PURE__ */ React.createElement(ThroughputCell, { input })),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    input_failures: {
      renderCell: (_failures, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id, section: EXPANDED_SECTION, align: "right" }, /* @__PURE__ */ React.createElement(FailuresCell, { input })),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    address: {
      renderCell: (_address, input) => {
        var _a;
        return /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id, section: EXPANDED_SECTION }, ((_a = input.attributes) == null ? void 0 : _a.bind_address) || "N/A");
      },
      staticWidth: 125
    },
    port: {
      renderCell: (_port, input) => {
        var _a;
        return /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id, section: EXPANDED_SECTION, align: "right" }, ((_a = input.attributes) == null ? void 0 : _a.port) || "N/A");
      },
      staticWidth: "matchHeader"
    },
    [METRIC_COLUMN_IDS.messagesPerStream]: {
      renderCell: (_value, input) => /* @__PURE__ */ React.createElement(MessageCountCell, { input }),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    [METRIC_COLUMN_IDS.extractorCount]: {
      renderCell: (_value, input) => /* @__PURE__ */ React.createElement(ExtractorCountCell, { input }),
      staticWidth: "matchHeader"
    },
    [METRIC_COLUMN_IDS.associatedStreams]: {
      renderCell: (_value, input) => /* @__PURE__ */ React.createElement(AssociatedStreamsCell, { input }),
      staticWidth: "matchHeader",
      textAlign: "right"
    }
  }
});
export default customColumnRenderers;
